import useDebounce from "hooks/others/useDebounce";
import { useInfiniteQuery, useQueryClient } from "react-query";
import { GetMyVacation } from "services/workSchedule";

export default function UseGetMyVacation(enabled: boolean) {
  return useInfiniteQuery(
    ["my-vacation"],
    async ({ pageParam = 1 }) => GetMyVacation(pageParam),
    {
      enabled,
      getNextPageParam: (lastPage) =>
        lastPage.meta.nextPageUrl
          ? lastPage.meta.currentPage + 1
          : undefined,
    }
  );
}